import React from 'react';
import { FaPhoneAlt } from 'react-icons/fa';

const PhoneCard = ({ title, phone, description, 'data-testid': dataTestId }) => (
  <a
    href={`tel:${phone}`}
    className="block p-4 bg-slate-50 border border-slate-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 hover:shadow-md transition-all duration-200 group"
    data-testid={dataTestId}
  >
    <div className="flex items-center gap-3">
      <div className="flex-shrink-0 w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center group-hover:bg-blue-100 transition-colors">
        <FaPhoneAlt className="text-blue-600" />
      </div>
      <div>
        <p className="font-medium text-gray-900">{title}</p>
        <p className="text-blue-600 font-semibold">{phone}</p>
        <p className="text-sm text-gray-500 mt-0.5">{description}</p>
      </div>
    </div>
  </a>
);

export default PhoneCard;
